exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tf-picto-recall {\n  height: 45px;\n  width: 40px;\n  margin-left: auto;\n  margin-right: auto;\n  opacity: 0.5;\n}\n.tf-picto-recall.selected {\n  height : 55px;\n  width : 50px;\n  opacity: 1;\n /*border: 1px solid red;*/\n box-shadow: 0 3px 5px -1px rgba(0,0,0,.3),0 6px 10px 0 rgba(0,0,0,.34),0 1px 18px 0 rgba(0,0,0,.32)!important;\n}\ntf-picto-recall.noSelected {\n  width : 50px;\n  width : 45px;\n  border: 0px solid;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/Visioconf.vue
// module id = oz+0
// module chunks = 1